(function () {
  'use strict';

  var raf = null;
  var resizeTimer = null;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getVisibleCount() {
    var width = window.innerWidth || document.documentElement.clientWidth;

    if (width >= 1280) {
      return 5;
    }

    if (width >= 1000) {
      return 4;
    }

    if (width >= 741) {
      return 3;
    }

    return 2;
  }

  function getParts(shell) {
    var viewport = shell && shell.querySelector('.tdl-product-recommendations-inner');
    var track = shell && shell.querySelector('.tdl-product-recommendations-grid');
    var previous = shell && shell.querySelector('.tdl-product-recommendations-arrow--prev');
    var next = shell && shell.querySelector('.tdl-product-recommendations-arrow--next');

    return {
      shell: shell,
      viewport: viewport,
      track: track,
      items: track ? toArray(track.querySelectorAll('.product-item')) : [],
      previous: previous,
      next: next
    };
  }

  function prepare(parts) {
    if (!parts.shell || !parts.viewport || !parts.track || !parts.items.length) {
      return;
    }

    var visible = Math.min(getVisibleCount(), parts.items.length);
    var gap = window.innerWidth <= 740 ? 12 : 16;
    var width = Math.max(118, Math.floor((parts.viewport.clientWidth - (gap * (visible - 1))) / visible));

    parts.shell.style.setProperty('--ls-carousel-gap', gap + 'px');
    parts.shell.style.setProperty('--ls-carousel-card-width', width + 'px');
    parts.shell.dataset.lsVisibleCount = String(visible);

    parts.items.forEach(function(item) {
      item.style.setProperty('flex-basis', width + 'px', 'important');
      item.style.setProperty('width', width + 'px', 'important');
      item.style.setProperty('min-width', width + 'px', 'important');
      item.style.setProperty('max-width', width + 'px', 'important');
    });
  }

  function getMaxOffset(parts) {
    return Math.max(0, parts.track.scrollWidth - parts.viewport.clientWidth);
  }

  function setOffset(parts, offset) {
    var max = getMaxOffset(parts);
    var nextOffset = Math.max(0, Math.min(offset, max));

    parts.shell.dataset.lsRecommendationOffset = String(nextOffset);
    parts.track.style.setProperty('transform', 'translate3d(' + (-nextOffset) + 'px, 0, 0)', 'important');
    parts.shell.classList.toggle('tdl-recommendations-is-scrollable', max > 4);

    if (parts.previous) {
      parts.previous.disabled = nextOffset <= 2;
      parts.previous.setAttribute('aria-disabled', nextOffset <= 2 ? 'true' : 'false');
    }

    if (parts.next) {
      parts.next.disabled = nextOffset >= max - 2;
      parts.next.setAttribute('aria-disabled', nextOffset >= max - 2 ? 'true' : 'false');
    }
  }

  function refreshShell(shell) {
    var parts = getParts(shell);

    if (!parts.shell || !parts.viewport || !parts.track || !parts.items.length) {
      return;
    }

    prepare(parts);
    setOffset(parts, parseFloat(parts.shell.dataset.lsRecommendationOffset || '0'));
  }

  function refreshAll() {
    raf = null;
    toArray(document.querySelectorAll('.tdl-product-recommendations-shell')).forEach(refreshShell);
  }

  function scheduleRefresh() {
    if (raf) {
      return;
    }

    raf = window.requestAnimationFrame(refreshAll);
  }

  function move(button, direction) {
    var shell = button.closest('.tdl-product-recommendations-shell');
    var parts = getParts(shell);

    if (!parts.shell || !parts.viewport || !parts.track) {
      return;
    }

    prepare(parts);

    var visible = parseInt(parts.shell.dataset.lsVisibleCount || '2', 10);
    var item = parts.items[0];
    var gap = parseFloat(getComputedStyle(parts.track).gap || '16') || 16;
    var step = item ? (item.getBoundingClientRect().width + gap) * Math.max(1, visible - 1) : parts.viewport.clientWidth;
    var current = parseFloat(parts.shell.dataset.lsRecommendationOffset || '0');

    setOffset(parts, current + direction * step);
  }

  function bind() {
    document.addEventListener('click', function(event) {
      var button = event.target.closest('.tdl-product-recommendations-arrow');

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      move(button, button.classList.contains('tdl-product-recommendations-arrow--prev') ? -1 : 1);
    }, true);

    window.addEventListener('resize', function() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(scheduleRefresh, 80);
    }, { passive: true });

    document.addEventListener('shopify:section:load', scheduleRefresh);
    document.addEventListener('shopify:section:select', scheduleRefresh);
  }

  function init() {
    if (window.lockstockPremiumRefinementReady) {
      scheduleRefresh();
      return;
    }

    window.lockstockPremiumRefinementReady = true;
    bind();
    scheduleRefresh();
    window.setTimeout(scheduleRefresh, 500);
    window.setTimeout(scheduleRefresh, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
